import moment from 'moment-timezone';
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import flattenDeep from 'lodash/fp/flattenDeep';
import { hasNextDaySuffix, stripNextDaySuffix } from './time-utils';
// Returns an empty string if can't produce an ISO string - may not be what you want!!
/* eslint-disable */ export var toISOString = function(date) {
    return date && typeof date.toISOString === 'function' ? date.toISOString() : '';
};
/* eslint-enable */ export var convertDate = function(time, timezone) {
    var date = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, daysOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, hoursOffset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, minutesOffset = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    if (time === 'Immediately') {
        var rv = moment().add(daysOffset, 'days').add(hoursOffset, 'hours').add(minutesOffset, 'minutes');
        return rv;
    }
    var isNextDayTime = hasNextDaySuffix(time);
    var actualTime = stripNextDaySuffix(time);
    var requestedDay = date ? moment.tz(date, timezone).format('MM-DD-YY') : moment().tz(timezone).format('MM-DD-YY');
    var requested = "".concat(requestedDay, " ").concat(actualTime);
    var rv1 = moment.tz(requested, 'MM-DD-YY hh:mmA', timezone).add(daysOffset, 'days').add(hoursOffset, 'hours').add(minutesOffset, 'minutes');
    // Add an extra day if it's a next-day time
    if (isNextDayTime) {
        rv1 = rv1.add(1, 'day');
    }
    return rv1;
};
export var formatDate = function(passedDate, format) {
    var date = _.isDate(passedDate) ? passedDate.toISOString() : passedDate;
    return moment(date).format(format);
};
/*
 * Get hours, by type, for the next openn day, accounting for
 * special hours
 */ export var findNextOpenDay = function(param) {
    var _param_serviceType = param.serviceType, serviceType = _param_serviceType === void 0 ? 'pickup' : _param_serviceType, _param_standardHours = param.standardHours, standardHours = _param_standardHours === void 0 ? {} : _param_standardHours, _param_specialHours = param.specialHours, specialHours = _param_specialHours === void 0 ? {} : _param_specialHours, _param_timezone = param.timezone, timezone = _param_timezone === void 0 ? 'US/Pacific' : _param_timezone, now = param.now, _param_addedDays = param.addedDays, addedDays = _param_addedDays === void 0 ? 0 : _param_addedDays;
    if (addedDays > 7 || !standardHours) {
        return {};
    }
    var specialHoursDays = flow(map('hoursPerDay'), flattenDeep)(specialHours);
    var nextDay = moment().tz(timezone).startOf('day').add(addedDays, 'days');
    var nextDayHours = standardHours[nextDay.format('dddd')];
    var specialHoursForNextDay = _.find(_.compact(specialHoursDays), function(param) {
        var date = param.date;
        return moment.tz(date, timezone).isSame(nextDay, 'day');
    });
    if (specialHoursForNextDay) {
        nextDayHours = specialHoursForNextDay.hours;
    }
    var start = nextDayHours.start === 'open' ? '12:00 AM' : nextDayHours.start;
    var end = nextDayHours.end === 'open' ? '12:00 AM' : nextDayHours.end;
    // Parse opening time (should not have Next Day suffix)
    var openMoment = moment.tz("".concat(nextDay.format('MM-DD-YY'), " ").concat(start), 'MM-DD-YY hh:mmA', timezone);
    var isNextDayEnd = hasNextDaySuffix(end);
    var actualEndTime = stripNextDaySuffix(end);
    // if open 24 hours, close is 12:00 am the next day
    var closeMoment = moment.tz("".concat(nextDay.clone().add(nextDayHours.end === 'open' || isNextDayEnd ? 1 : 0, 'day').format('MM-DD-YY'), " ").concat(actualEndTime), 'MM-DD-YY hh:mmA', timezone);
    /* return hours for the first day that is either:
   *   a. today and the store has not yet closed
   *   b. after today
   */ if (nextDayHours.active && (now.isBefore(closeMoment) || !nextDay.isSame(now, 'day'))) {
        return {
            date: nextDay,
            openMoment: openMoment,
            closeMoment: closeMoment
        };
    }
    return findNextOpenDay({
        serviceType: serviceType,
        standardHours: standardHours,
        specialHours: specialHours,
        timezone: timezone,
        now: now,
        addedDays: addedDays + 1
    });
};
export var guessTimezone = function() {
    var guess = moment.tz.guess();
    if ([
        'America/New_York',
        'America/Detroit'
    ].includes(guess)) {
        return 'US/Eastern';
    }
    if (guess === 'America/Chicago') {
        return 'US/Central';
    }
    if ([
        'America/Denver',
        'America/Boise'
    ].includes(guess)) {
        return 'US/Mountain';
    }
    if ([
        'America/Los_Angeles',
        'America/Vancouver'
    ].includes(guess)) {
        return 'US/Pacific';
    }
    return guess;
};
